/**
 * Formats the number informed based on the currency code
 */
function formatCurrency(
  code: string,
  number: number,
  forceUseCurrencySymbol: boolean
): string {
  let formattedParts;

  try {
    formattedParts = new Intl.NumberFormat(navigator.language, {
      style: "currency",
      currency: code,
      minimumFractionDigits: 0,
      currencyDisplay: "narrowSymbol",
      notation: "compact",
      compactDisplay: "short",
      maximumSignificantDigits: 3
    }).formatToParts(number);
  } catch (err) {
    formattedParts = new Intl.NumberFormat(navigator.language, {
      style: "currency",
      currency: code,
      minimumFractionDigits: 0,
      currencyDisplay: "symbol",
      maximumSignificantDigits: 3
    }).formatToParts(number);
  }

  const formatted = formattedParts
    .map(formattedPart => {
      const { type, value } = formattedPart;
      const shouldIgnoreCurrency =
        type === "currency" && value.length >= 3 && !forceUseCurrencySymbol;
      if (shouldIgnoreCurrency) {
        return "";
      }
      return value;
    })
    .join("")
    .trim();

  return formatted;
}

export default formatCurrency;
